import React from 'react'
import PropTypes from 'prop-types';
import compose from 'lodash.compose';
import { translate } from 'react-i18next';
import Link from '../../link';
import Logo from '../../logo';


function Header({ t, onToggleMenu, i18n: { language } }) {
  return (
    <header id="header" className="alt">
      <Link prefetch href="/">
        <a className="logo">
          <Logo />
        </a>
      </Link>
      <nav id="navbar">
        {/*<input type="search" style={{ width: '30%', marginTop: 5}} />*/}
        <ul>
          <li className="menu-link">
            <Link prefetch href="/">
              <a>
                {t('menu.home')}
              </a>
            </Link>
          </li>
          <li className="menu-link">
            <Link prefetch href="/catalogues">
              <a>
                {t('menu.catalogues')}
              </a>
            </Link>
          </li>
          <li className="menu-link">
            <Link prefetch href="/downloads">
              <a>
                {t('menu.downloads')}
              </a>
            </Link>
          </li>
          <li className="menu-link">
            <Link prefetch href="/videos">
              <a>
                {t('menu.videos')}
              </a>
            </Link>
          </li>
          <li className="menu-link">
            <span className="dropdown">
              <a href="javascript:void(0)" className="dropbtn">{t('menu.about')}</a>
              <div className="dropdown-content">
                <Link prefetch href="/about">
                  <a className="menu-link">
                    {t('menu.company')}
                  </a>
                </Link>
                <Link prefetch href="/about/certificates">
                  <a className="menu-link">
                    {t('menu.certificates')}
                  </a>
                </Link>
              </div>
            </span>
          </li>
          <li className="menu-link search">
            <form method="get" action={`/${language}/search`}>
              <input
                type="search"
                name="search"
                id="code"
                placeholder="Codice o cross-reference"
                autoComplete="false"
              />
            </form>
          </li>
          <li className="menu-link mobile-menu">
            <a onClick={onToggleMenu} href="javascript:;">
              {t('menu.menu')} <i className="fa fa-bars" />
            </a>
          </li>
        </ul>
      </nav>
    </header>
  )
}

Header.defaultProps = {};
Header.propTypes = {
  onToggleMenu: PropTypes.func.isRequired
};
export default compose(
  translate(),
)(Header);
